module.exports = __webpack_public_path__ + "media/styles/images/svg/arrow-down-gray-042af77853a1a84a52d7739753b9f44c.svg";